/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const DiscountTagFill: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M11.1824 2.91204C11.9184 2.17607 12.9743 1.85635 13.9949 2.06047L19.5975 3.18059C20.2136 3.30382 20.6959 3.78613 20.8191 4.40227L21.9393 10.0048C22.1434 11.0254 21.8237 12.0813 21.0877 12.8173L12.3611 21.5439C11.7533 22.1517 10.7678 22.1517 10.16 21.5439L2.45585 13.8398C1.84806 13.2319 1.84804 12.2464 2.45585 11.6386L11.1824 2.91204ZM17.4139 6.58586C16.6328 5.80482 15.3668 5.80482 14.5857 6.58586C13.8047 7.36691 13.8047 8.63294 14.5857 9.41399C15.3668 10.195 16.6328 10.195 17.4139 9.41399C18.1949 8.63294 18.1949 7.36691 17.4139 6.58586Z'
      fill='currentColor'
    />
  </React.Fragment>
)
